import { render, staticRenderFns } from "./SkeletonCheckbox.vue?vue&type=template&id=7b8b667a&scoped=true&"
import script from "./SkeletonCheckbox.vue?vue&type=script&lang=js&"
export * from "./SkeletonCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonCheckbox.vue?vue&type=style&index=0&id=7b8b667a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b667a",
  null
  
)

export default component.exports